<div class="bmc-working-time-schema-calendar">
  <p class="bmc-working-time-schema-calendar__title">{{'WORKING_TIME_SCHEMA.CALENDAR_MANDATORY_TITLE' | translate}}</p>
  <div class="bmc-working-time-schema-calendar__section-select">
    <strong
      class="bz-space--stack-xs bmc-working-time-schema-calendar__label">{{'WORKING_TIME_SCHEMA.DATE_TYPE' | translate}}</strong>
    <bzg-select class="bz-space--stack-m" [placeholder]="'WORKING_TIME_SCHEMA.SELECT_DATE_TYPE' | translate"
      [(value)]="currentDateType">
      <bzg-option value="exact">{{'WORKING_TIME_SCHEMA.EXACT' | translate}}</bzg-option>
      <bzg-option value="range">{{'WORKING_TIME_SCHEMA.RANGE' | translate}}</bzg-option>
    </bzg-select>
  </div>
  <div class="bmc-working-time-schema-calendar__section-date">
    <bzg-date-picker [(ngModel)]="onDate" *ngIf="currentDateType==='exact'" class="bmc-working-time-schema-calendar__date bz-space--inline-m">
      {{'WORKING_TIME_SCHEMA.ON_DATE' | translate}}
    </bzg-date-picker>
    <bzg-date-picker class="bmc-working-time-schema-calendar__date bz-space--inline-m" *ngIf="currentDateType==='range'" [(ngModel)]="startDate" [maxDate]="finishDate" name="start-date">
      {{'WORKING_TIME_SCHEMA.START_DATE' | translate}}
    </bzg-date-picker>
    <bzg-date-picker class="bmc-working-time-schema-calendar__date bz-space--inline-m" *ngIf="currentDateType==='range'" [(ngModel)]="finishDate" [minDate]="startDate" name="finish-date">
      {{'WORKING_TIME_SCHEMA.FINISH_DATE' | translate}}
    </bzg-date-picker>
    <bzg-button-secondary *ngIf="currentDateType" class="bz-space--inline-m bz-space--stack-xs bmc-working-time-schema-calendar__button" [size]="'s'" (click)="applyResetOnDays()">
      {{'WORKING_TIME_SCHEMA.SETUP_ORIGINAL_SETTINGS' | translate}}</bzg-button-secondary>
  </div>
</div>